export default "__VITE_ASSET__CnPrGG12__"